module.exports = __webpack_public_path__ + "img/circle-gold-blank-large.8c257d9b.png";